import * as React from "react";
import { forwardRef } from "react";
import { cn } from "src/common/utils";

export const ChatMessageList = forwardRef<
  HTMLDivElement,
  React.HTMLProps<HTMLDivElement>
>(({ children, className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        "flex flex-col w-full h-full gap-6 overflow-y-auto overflow-x-hidden custom-scrollbar",
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
});

ChatMessageList.displayName = "ChatMessageList";
